import request from '@/utils/request'

const pictureURL = {
  Add: '/pictures/create',
  List: '/pictures/list',
  Detail: '/pictures/view',
  Update: '/pictures/update',
  Delete: '/pictures/delete',
  Sort: '/pictures/sort-update',
  Params: '/pictures/params-update',
  Status: '/pictures/state-update',
  UpdatePath: '/pictures/path-update',
  repeatCheck: '/pictures/repeat-check'
}

// 图片列表
export function listPicture (data) {
  return request({
    url: pictureURL.List,
    method: 'post',
    data
  })
}

// 图片详情
export function detailPicture (data) {
  return request({
    url: pictureURL.Detail,
    method: 'post',
    data
  })
}

// 创建图片
export function AddPicture (data) {
  return request({
    url: pictureURL.Add,
    method: 'post',
    data
  })
}

// 图片详情更新
export function updatePicture (data) {
  return request({
    url: pictureURL.Update,
    method: 'post',
    data
  })
}

// 图片删除
export function deletePicture (data) {
  return request({
    url: pictureURL.Delete,
    method: 'post',
    data
  })
}

// 图片-路径-更新
export function updatePathPicture (data) {
  return request({
    url: pictureURL.UpdatePath,
    method: 'post',
    data
  })
}

// 图片-排序更新
export function sortPicture (data) {
  return request({
    url: pictureURL.Sort,
    method: 'post',
    data
  })
}

// 图片-状态更新
export function statusPicture (data) {
  return request({
    url: pictureURL.Status,
    method: 'post',
    data
  })
}

// 图片-参数更新
export function paramsPicture (data) {
  return request({
    url: pictureURL.Params,
    method: 'post',
    data
  })
}

// 重复检查接口
export function repeatCheck (data) {
  return request({
    url: pictureURL.repeatCheck,
    method: 'post',
    data
  })
}

export default {
  AddPicture,
  listPicture,
  detailPicture,
  updatePicture,
  deletePicture,
  sortPicture,
  statusPicture,
  paramsPicture,
  updatePathPicture,
  repeatCheck
}
